import { render } from "./CaptainToolsSettings.vue?vue&type=template&id=56c14959"
import script from "./CaptainToolsSettings.vue?vue&type=script&lang=js"
export * from "./CaptainToolsSettings.vue?vue&type=script&lang=js"
script.render = render

export default script